<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="生产入库单"
      :page="page"
      :show-query="true"
      :get-data-func="api.list"
      @row-select="rowSelect"
      v-if="trendShow"
      :temp-params="tempParams"
      urlHash="production/ticketmanagement/workshopprofit"

    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <el-table  border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;">
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="Quantity" label="本次报损数" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="center"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="center"></el-table-column>
      <el-table-column prop="UnitName" label="计量单位" min-width="100" align="center"></el-table-column>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="center"></el-table-column>
      <el-table-column prop="Price" label="单价" min-width="100" align="center" v-if="canPrice"></el-table-column>
      <el-table-column prop="Amount" label="金额" min-width="100" align="center" v-if="canPrice"></el-table-column>
    </el-table>
  </div>
</template>
<script>


import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    // canPrice: {
    //   typeof: Boolean,
    //   default: true,
    // }
  },
  data() {
    return {
      api: require("@/api/pr/workshopprofit").default,
      // sourceTypeApi:require("@/api/ba/sourceType").default,
      trendShow: true,
      tableData: [],
      tempParams: {
        // DocType: 20,
      }
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/inventoryoverflow");
    },
  },
  //  created() {
  //     this.sourceTypeApi.info("库存溢损单").then(res=> {
  //         this.tempParams.DocType=res.SourceTypeId
  //     });
  // },
  methods: {
    rowSelect(row){
      let id = row.ProfitLossId;
      this.api.info(id).then(res => {
          this.tableData = res.Data.ProfitLossModelDts;
      })
    }
  }
};
</script>
